import { list, Filter } from "@mc/mc-legacy";
import QSignDataApi from "../api/gen/qsign/QSignDataApi";
import QSignSearchApi from "../api/gen/qsign/QSignSearchApi";

export const PRE_POZADAVKY_SEARCH_LIST = "prePozadavkySearchList";

const getRequestsByIds = (ids) => {
  return QSignDataApi.findRequestDocumentsByIds(ids);
};

const purify = ({ dateRange, ...filter }) => {
  return { ...filter, dateRange: dateRange ? dateRange : null };
};

const findAllIds = (parent, filter) => {
  return QSignSearchApi.searchSignRequestDocuments(purify(filter));
};

export function fetchIfNeeded(forceFetch) {
  return (dispatch) => {
    dispatch(
      list.InfiniteListActions.fetchIfNeeded(PRE_POZADAVKY_SEARCH_LIST, null, findAllIds, getRequestsByIds, forceFetch)
    );
  };
}
export function loadMore() {
  return (dispatch, getState) => {
    dispatch(list.InfiniteListActions.loadMore(PRE_POZADAVKY_SEARCH_LIST, getRequestsByIds));
  };
}
export function invalidate() {
  return (dispatch) => {
    dispatch(list.InfiniteListActions.invalidate(PRE_POZADAVKY_SEARCH_LIST));
  };
}
export function filter(filter) {
  const { ...otherFilterFields } = Filter.purifyValues(filter);
  return (dispatch) => {
    dispatch(list.InfiniteListActions.filter(PRE_POZADAVKY_SEARCH_LIST, otherFilterFields));
  };
}
